
import { Button } from "@/components/ui/button";
import { cn } from "@/lib/utils";
import { Menu, PanelLeft } from "lucide-react";
import { useSidebar } from "@/components/ui/sidebar";
import { useIsMobile } from "@/hooks/use-mobile";
import { useLocation } from "react-router-dom";

export const SidebarToggle = () => {
  const { open, setOpen, openMobile, setOpenMobile } = useSidebar();
  const isMobile = useIsMobile();
  const location = useLocation();
  
  // Don't show the toggle on the habit tracker page where we have our own
  const isHabitTracker = location.pathname === "/";
  if (isHabitTracker) return null;
  
  const toggleSidebar = () => {
    if (isMobile) {
      setOpenMobile(!openMobile);
    } else {
      setOpen(!open);
    }
  };
  
  // Don't render on desktop where the sidebar is always visible
  if (!isMobile) return null;
  
  return (
    <Button
      variant="outline"
      size="icon"
      onClick={toggleSidebar}
      className="fixed bottom-4 right-4 z-50 rounded-full shadow-lg bg-white/90 backdrop-blur"
    >
      <Menu className="h-6 w-6" />
    </Button>
  );
};
